export enum SingleValueFilterOperation {
   Contains = 'Contains',
   EndsWith = 'EndsWith',
   EqualTo = 'EqualTo',
   GreaterThan = 'GreaterThan',
   GreaterThanOrEqualTo = 'GreaterThanOrEqualTo',
   GreaterThanOrEqualToOrNull = 'GreaterThanOrEqualToOrNull',
   GreaterThanOrNull = 'GreaterThanOrNull',
   LessThan = 'LessThan',
   LessThanOrEqualTo = 'LessThanOrEqualTo',
   LessThanOrEqualToOrNull = 'LessThanOrEqualToOrNull',
   LessThanOrNull = 'LessThanOrNull',
   NotEqualTo = 'NotEqualTo',
   StartsWith = 'StartsWith',
   EqualToOrNull = 'EqualToOrNull',
}
